/**
 *
 * @param props
 * @param ref$
 */
export const applyRef = (props: { [key: string]: any }, ref$: any) => {
    if (!props.ref) {
        props.ref = ref$;
    }

    return props;
};
